export const MANIFEST_URL =
	'https://raw.githubusercontent.com/ALLTERCO/shelly-script-examples/main/examples-manifest.json';

// Fallback source when GitHub Raw is rate-limited or unavailable
export const MANIFEST_FALLBACK_URL =
	'https://gitlab.allterco.net/Shelly/fw/shelly-script-examples/-/raw/main/examples-manifest.json';

export const REPO_RAW_BASE = 'https://raw.githubusercontent.com/ALLTERCO/shelly-script-examples/main/';

export const GITHUB_REPO_BASE = 'https://github.com/ALLTERCO/shelly-script-examples/blob/main/';

// localStorage key for caching the last successfully fetched manifest
export const MANIFEST_CACHE_KEY = 'shelly_scripts_library_manifest';
